export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq5f_sell.3038370d.mp3";